import * as yup from 'yup';
import { AssetBucketingDTO, BucketDTO } from './api/useAssetBucketQuery';

export interface FormFieldValues extends AssetBucketingDTO {}

export const EMPTY_BUCKET = {
  title: '',
  description: '',
  classifications: [],
};

const bucketValidation = yup
  .object()
  .shape({
    title: yup
      .string()
      .nullable()
      .required('Please enter a Bucket Name'),

    description: yup
      .string()
      .nullable()
      .required('Please enter a Bucket Description'),

    classifications: yup
      .array()
      .test('classifications', (value, { options, createError, path }) => {
        const { from } = options as { from: { value: FormFieldValues }[] };

        const {
          value: { enableManagementStylesBucketing },
        } = from[1];

        if (!!value && value.length === 0) {
          return createError({
            message: `Please add at least one ${
              enableManagementStylesBucketing ? 'Orion Management Style' : 'Asset'
            }`,
            path,
          });
        }

        return !!value && value.length > 0;
      }),
  })
  .test('unique-title', 'Please enter a unique bucket name', function uniqueTitle(bucket) {
    if ((this.parent as BucketDTO[]).filter(({ title }) => title === bucket.title).length > 1) {
      throw this.createError({ path: `${this.path}.title` });
    }

    return true;
  });

export const validation = yup.object().shape({
  headline: yup
    .string()
    .nullable()
    .required('Please enter a Headline'),

  supportingText: yup
    .string()
    .nullable()
    .required('Please enter a Supporting text'),

  buckets: yup.array().of(bucketValidation),
});
